<header class="w3-highway-red">
  <a href="/">Kaya S-Weather</a>
</header>

<style lang="scss">
  header {
    overflow: hidden;

    font-family: Arial;
    text-align: center;
    padding: 1rem;

    a {
      color: white;
      text-decoration: none;
      cursor: pointer;
      font-size: 2rem;
    }
  }
</style>
